import {firenaseCodes, messageDefault} from '@/services/message.service'

let message = ''

export const getMessage = () => {
    return message
}

export const setMessage = (errorCode) => {
    message = firenaseCodes[errorCode]
    if (!message) {
        message = messageDefault['default']
    }
}